import { AddBtn } from '../TableAddRowButton'
import { Link } from 'react-router-dom'

type TableWrapperProps = {
  onAdd: () => void
  title: string
  designPlanPath?: string
  children: React.ReactNode
}

export const TableWrapper: React.FC<TableWrapperProps> = ({
  onAdd,
  title,
  designPlanPath,
  children,
}) => {
  return (
    <div className="customer">
      <div className="subtitle-section">
        <p className="subtitle">{title}</p>
        {designPlanPath && (
          <Link className="design-plan-link" to={designPlanPath}>
            요금제 설계하기
          </Link>
        )}
      </div>
      {children}
      <div className="add-row-section">
        <AddBtn onAdd={onAdd} />
      </div>
    </div>
  )
}
